import React, {Component} from "react";
import {Grid, Avatar, Typography, Button, Hidden, ButtonGroup} from "@material-ui/core";
import {connect} from "react-redux";

import {webFont, textBlack, textGrey, primaryColor} from "../../config/theme";
import {client} from "../../config/apollo";
import DishesListBox from "../DishesListBox";

import {DISHES_BY_CHEF, FIND_DISHES} from "../../graphql/queries/dishes";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

const defaultChefImg = "/images/simple-chef.webp";

class DList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      dishesList: [],
      loading: false,
      isLive: true,
    };
    this.mediaBoxRef = React.createRef();
  }

  fetchDishes = () => {
    let {pageSize, filters, next, previous, type, isChef} = this.props;
    if (!isChef) {
      type = "all";
    }

    switch (type) {
      default:
        this.fetchAll();
        return;

      case "dishesByChef":
        this.getDishesByChef(filters.chefId, pageSize, next, previous);
        break;
      case "all":
        this.fetchAll();
        break;
    }
  };

  componentDidMount() {
    this.fetchDishes();
    if (this.props.onRef)
      this.props.onRef(this);
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.filters) !== JSON.stringify(prevProps.filters)) {
      this.fetchDishes();
    }
  }

  handleClick = dish => {
    const {isChef, userId, history} = this.props;

    if (isChef && userId === dish.chefId) {
      history.push("/home/add-dish", {dish});
    } else {
      history.push({
        pathname: "/home/dish-details",
        search: `dishId=${dish.id}`,
        state: {dishId: dish.id, screen: 'dish-search'}
      });
    }
  };

  fetchAll = () => {
    this.setState({loading: true});
    const filtersFromLocal = JSON.parse(localStorage.getItem("dishFilters"));
    const updatedFilters = {...this.props.filters, ...filtersFromLocal};
    if (this.props.filters) {
      if (updatedFilters.hasOwnProperty("search")) {
        if (updatedFilters.search !== 'a' && updatedFilters.search.length > 1) {
          updatedFilters.searchType = "DISH_NAME";
        } else {
          updatedFilters.searchType = "";
        }
      }
    }

    //const { filters } = this.props;
    const filters = updatedFilters.searchType === 'DISH_NAME' ?
      {search: updatedFilters.search, searchType: updatedFilters.searchType} :
      {...updatedFilters};
    if (this.props.location && this.props.location.pathname && this.props.location.pathname === '/home/dish-search' && !this.props.isChef) {
      if (filters.chefId) {
        delete filters.chefId;
      }
    }

    const dishFilters = {};

    if (filters.engagement > 0) {
      dishFilters.engagementSize = filters.engagement;
    }

    if (filters.engagementSize > 0) {
      dishFilters.engagementSize = filters.engagementSize;
    }

    if (!!filters.priceMin && filters.priceMin > 0 && !!filters.priceMax && filters.priceMax > 0) {
      dishFilters.priceMin = filters.priceMin;
    }

    if (!!filters.priceMax && filters.priceMax > 0 && !!filters.priceMin && filters.priceMin > 0) {
      dishFilters.priceMax = filters.priceMax;
    }

    if (!!filters.dishes && filters.dishes.length > 0) {
      dishFilters.dishes = filters.dishes;
    }

    if (!!filters.cuisines && filters.cuisines.length > 0) {
      dishFilters.cuisines = filters.cuisines;
    }

    if (!!filters.dishTypes && filters.dishTypes.length > 0) {
      dishFilters.dishTypes = filters.dishTypes;
    }

    if (filters.search !== 'a' && filters.search !== '?all=true' && !filters) {
      dishFilters.search = filters.search;
      dishFilters.searchType = "DISH_NAME";
    }

    if (Object.keys(dishFilters).length === 0 && dishFilters.constructor === Object) {
      if (!!filters.search && filters.search !== 'a' && filters.search !== '?all=true' && filters.search.length > 2) {
        dishFilters.search = filters.search;
        dishFilters.searchType = "DISH_NAME";
      } else {
        dishFilters.engagementSize = 1;
      }
    }

    client
      .query({
        query: FIND_DISHES,
        variables: {
          filters: dishFilters,
          includeChefs: true,
          pageSize: 100,
          next: null,
          previous: null
        },
        fetchPolicy: "network-only"
      })
      .then(resp => {
        this.setState({loading: false});

        if (resp.data) {
          if (resp.data.findDishes) {
            this.setState({dishesList: resp.data.findDishes.dishes});
          }
        }
      })
      .catch(err => {
        console.error("CHEF Dishes: ", err);
        this.setState({loading: false});
        let errorObj = JSON.parse(JSON.stringify(err));
        console.error(errorObj);
      });
  };

  getDishesByChef = (chefId, pageSize, previous, next) => {
    this.setState({loading: true});
    const payload = {
      chefId,
      pageSize,
      next,
      previous
    };

    if (this.props.isLiveShow) {
      payload.live = this.state.isLive;
    }

    client
      .query({
        query: DISHES_BY_CHEF,
        variables: payload,
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.dishesByChef) {
            this.setState({
              dishesList: resp.data.dishesByChef.dishes,
              loading: false
            });
          }
        }
      })
      .catch(err => {
        this.setState({loading: false});
        console.error(JSON.parse(JSON.stringify(err)));
      });
  };

  handleAlignment = (e) => {
    this.setState({isLive: !this.state.isLive}, () => {
      const {pageSize, filters, next, previous} = this.props;
      this.getDishesByChef(filters.chefId, 30, next, previous);
    });
  };

  renderDishes = (clientWidth) => {
    const {dishesList, isLive} = this.state;
    let {isShowAll, isLiveShow} = this.props;
    if (dishesList.length <= 4) {
      isShowAll = false;
    }

    let fChefs = <div></div>;
    if (dishesList.length > 0) {

      fChefs = dishesList.map(dish => {
        let dishMedia = {
          url: 'https://qa.cuisinecrafters.net/images/simple-chef.webp'
        };
        let cuisines = (dish.cuisines && dish.cuisines.length > 0) ? dish.cuisines.length > 3 ? 'Multi cuisines' : dish.cuisines.toString() : "No Cuisines";
        cuisines = cuisines.replace(/,/g, ", ");
        let chef = null;

        if (dish.media.length > 0) {
          dishMedia = dish.media[0];
        }

        if (isLiveShow && dish.isDraft !== isLive) {
          return (
            <DishesListBox
              dishImage={dishMedia ? dishMedia.url : defaultChefImg}
              dishHeading={dish.name}
              dishDetail={(dish.cuisines && dish.cuisines.length > 0) ? dish.cuisines.length > 3 ? 'Multi cuisines' : dish.cuisines.toString() : "No Cuisines"}
              dishChef={dish.chefName}
              dish={dish}
              handleClick={this.handleClick}
            />
          );
        } else {
          return (
            <React.Fragment>
                <DishesListBox
                  dishImage={dishMedia ? dishMedia.url : defaultChefImg}
                  dishHeading={dish.name}
                  dishDetail={cuisines}
                  dish={dish}
                  dishChef={dish.chefName}
                  handleClick={this.handleClick}
                />
            </React.Fragment>
          );
        }

      });
    }

    return fChefs;
  };

  render() {
    const {dishesList, isLive} = this.state;
    let {isShowAll, isLiveShow} = this.props;
    if (dishesList.length < 1) {
      isShowAll = false;
    }

    const clientWidth = this.mediaBoxRef ? this.mediaBoxRef.current ? this.mediaBoxRef.current.clientWidth : 510 : 510;

    let fChefs = this.renderDishes(clientWidth);
    const styleButton = {
      toggleItemSelect: {
        backgroundColor: isLive ? "#ff8000" : "#ffffff",
        color: !isLive ? "#ff8000" : "#ffffff",
        borderBottomLeftRadius: 50,
        borderTopLeftRadius: 50,
        borderColor: primaryColor, borderStyle: 'solid',
        width: 120,
        textTransform: 'none',
        fontSize: 18,
      },
      toggleItemUnselect: {
        backgroundColor: !isLive ? "#ff8000" : "#ffffff",
        color: isLive ? "#ff8000" : "#ffffff",
        borderBottomRightRadius: 50,
        borderColor: primaryColor, borderStyle: 'solid',
        borderTopRightRadius: 50,
        width: 120,
        height: 44,
        textTransform: 'none',
        fontSize: 18,
      }
    };

    const filters =
      this.props.type === "dishesByChef" ? {search: "", isLiveShow:true} : {search: "a", isLiveShow:true};
    return (
      <Grid container direction="row" style={{...style.ftGrid}} ref={this.mediaBoxRef}>
        {this.state.loading && (
          <Grid item md={12} style={{textAlign: "center"}}>
            <CircularProgress color="primary"/>
          </Grid>
        )}

        {isLiveShow &&
        <Grid container lg={12} xl={12} sm={12} xs={12} justify={'center'} style={{margin: '20px 0 32px'}}>
          <ButtonGroup
            onClick={this.handleAlignment.bind(this)}
          >
            <Button  data-test-id={"livedish"} value="left" style={styleButton.toggleItemSelect}>
              Live
            </Button>
            <Button  data-test-id={"draftdish"} value="right" style={styleButton.toggleItemUnselect}>
              <Typography>Drafts</Typography>
            </Button>
          </ButtonGroup>
        </Grid>}

        <Grid className="dish-container" container alignItems={'center'}>
          <div className="dish-conatiner-row">
            {fChefs}
          </div>
        </Grid>
        {this.state.dishesList.length <= 0 &&
        !this.state.loading && (this.props.page === 'Portfolio' || this.props.isChef) &&  (
          <Grid container alignItems="center" justify="center" style={{
            backgroundColor: '#e8e8e8',
            border: '2px solid #ff8000',
            borderRadius: 5,
            paddingTop: 100,
            paddingBottom: 100,
            margin: '20px auto 0px',
            maxWidth: 1140,
          }}
                onClick={this.props.addDishClick}>
            <Typography
              variant="h5"
              style={{
                fontFamily: webFont,
                color: textBlack,
                fontWeight: 500,
                marginBottom: 30,
                width: '100%',
                textAlign: 'center',
                marginTop: 30
              }}
            >
              Add a dish
            </Typography>
          </Grid>
        )}
        {this.state.dishesList.length <= 0 &&
        !this.state.loading && !this.props.isChef && this.props.page !== 'Portfolio' && (
          <Grid container alignItems="center" justify="center">
            <Typography
              variant="h5"
              style={{
                fontFamily: webFont,
                color: textBlack,
                fontWeight: 500,
                marginBottom: 30,
                width: '100%',
                textAlign: 'center',
                marginTop: 30
              }}
            >
              No dishes found.
            </Typography>
          </Grid>
        )}

        {isShowAll && this.state.dishesList.length > 0 && <Grid container alignItems="center" justify="center">
          <Button
            data-test-id={"showalldish"}
            variant="contained"
            color="primary"
            style={style.showBtn}
            onClick={() => this.props.history.push("/home/dish-search", filters)}
          >
            Show All
          </Button>
        </Grid>}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};

/*const DListWithData = compose(
	graphql(DISHES_BY_CHEF, {name: 'dishesByChef'}),
	graphql(FIND_DISHES, {name: 'findDishes'}),
)(DList);*/

const DishesList = connect(mapStateToProps)(DList);

export default DishesList;

const style = {
  avatarImg: {
    width: '100%',
    height: 230,
    borderRadius: 5
  },
  avatarImgIPadL: {
    width: '100%',
    height: 205,
    borderRadius: 5
  },
  avatarImgIPad: {
    width: '100%',
    height: 190,
    borderRadius: 5
  },
  avatarImgMob: {
    width: 320,
    height: 320,
    borderRadius: 5,
    marginLeft: 40
  },
  ftGrid: {
    marginTop: 20,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    fontSize: 15,
  },
  dishChefName: {
    fontFamily: webFont,
    color: textGrey,
    weight: 300,
    maxWidth: 300,
    fontSize: 12,
    marginTop: -5
  },
  dishName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    maxWidth: 400,
    margin: '10px 0 2px',
    fontSize: 20,
  },
  featuredItem: {
    marginTop: 32,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    padding: '8px 20px',
    textTransform: "none",
    marginTop: 40,
    fontFamily: webFont,
    fontSize: 15,
    fontWeight: 'normal',
    color: '#fff'
  }
};
